var map = {
	"./components/projects/projects.module": [
		"./src/app/components/projects/projects.module.ts",
		"common",
		"components-projects-projects-module"
	],
	"./components/services/services.module": [
		"./src/app/components/services/services.module.ts",
		"components-services-services-module"
	],
	"./components/team/team.module": [
		"./src/app/components/team/team.module.ts",
		"components-team-team-module"
	],
	"./components/technologies/technologies.module": [
		"./src/app/components/technologies/technologies.module.ts",
		"common",
		"components-technologies-technologies-module"
	],
	"./components/testimonials/testimonials.module": [
		"./src/app/components/testimonials/testimonials.module.ts",
		"components-testimonials-testimonials-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;